import { useVivnetworks } from "~/composables/useVivnetworks";

export default defineNuxtRouteMiddleware(async (to, from) => {

  useVivnetworks().registerAffiliatedRequest(to.query);

});